import { render } from "./UnpublishEventCard.vue?vue&type=template&id=28f0d4e5"
import script from "./UnpublishEventCard.vue?vue&type=script&lang=js"
export * from "./UnpublishEventCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__